import { Tooth, OdontogramAction, OdontogramState } from './odontogram.types';

export const initialState: OdontogramState = {
  adultoCima: [],
  adultoBaixo: [],
  criancaCima: [],
  criancaBaixo: [],
};

const updateDenteInArcada = (
  arcada: Tooth[],
  denteAtualizado: Tooth,
): Tooth[] => {
  return arcada.map((dente) =>
    dente.id === denteAtualizado.id ? denteAtualizado : dente,
  );
};

export function odontogramReducer(
  state: OdontogramState,
  action: OdontogramAction,
): OdontogramState {
  switch (action.type) {
    case 'SET_ARCADAS':
      return action.payload;
    case 'UPDATE_DENTE': {
      const { arcada, dente } = action.payload;
      return {
        ...state,
        [arcada]: updateDenteInArcada(state[arcada], dente),
      };
    }
    default:
      return state;
  }
}
